// extracted by mini-css-extract-plugin
module.exports = {"inbox":"row_inbox__2HbtW","left":"row_left__1VGou","right":"row_right__veZn_"};